import React from 'react'

import CheckboxDropdown from '@SonarCX/components/atoms/CheckboxDropdown'

const SingleUser = ({ selected, onSelect, ...props }) => {
  const handleSelect = React.useCallback(
    (id, checked) => {
      onSelect(checked ? id : null)
    },
    [onSelect]
  )

  const ddProps = {
    selected: [selected].filter(Boolean),
    onSelect: handleSelect,
    useRadio: true
  }

  return <CheckboxDropdown {...ddProps} {...props} />
}

export default SingleUser
